import styled from 'styled-components';
var FormGroup = styled.div.withConfig({
  displayName: "FormGroupstyles__FormGroup",
  componentId: "sc-9l6d5t-0"
})(["margin:var(--dentsu-spacing-40) 0;"]);
var Divider = styled.div.withConfig({
  displayName: "FormGroupstyles__Divider",
  componentId: "sc-9l6d5t-1"
})(["background:var(--dentsu-color-n300);margin:var(--dentsu-spacing-40) 0;width:100%;height:1px;"]);
var FormHeader = styled.div.withConfig({
  displayName: "FormGroupstyles__FormHeader",
  componentId: "sc-9l6d5t-2"
})(["margin-bottom:var(--dentsu-spacing-24);"]);
var FormTitle = styled.h2.withConfig({
  displayName: "FormGroupstyles__FormTitle",
  componentId: "sc-9l6d5t-3"
})(["color:var(--dentsu-color-n975);font-size:var(--dentsu-font-size-24);font-weight:var(--dentsu-font-weight-semibold);line-height:var(--dentsu-leading-tight);"]);
var GroupHeader = styled.div.withConfig({
  displayName: "FormGroupstyles__GroupHeader",
  componentId: "sc-9l6d5t-4"
})(["margin-bottom:var(--dentsu-spacing-24);"]);
var GroupTitle = styled.h3.withConfig({
  displayName: "FormGroupstyles__GroupTitle",
  componentId: "sc-9l6d5t-5"
})(["color:var(--dentsu-color-n975);font-size:var(--dentsu-font-size-20);font-weight:var(--dentsu-font-weight-semibold);line-height:var(--dentsu-leading-tight);"]);
var Description = styled.p.withConfig({
  displayName: "FormGroupstyles__Description",
  componentId: "sc-9l6d5t-6"
})(["color:var(--dentsu-color-n700);font-size:var(--dentsu-font-size-14);font-weight:var(--dentsu-font-weight-regular);line-height:var(--dentsu-leading-normal);font-style:var(--dentsu-font-style-italic);"]);
export var Styled = {
  Description: Description,
  Divider: Divider,
  FormHeader: FormHeader,
  FormGroup: FormGroup,
  FormTitle: FormTitle,
  GroupHeader: GroupHeader,
  GroupTitle: GroupTitle
};